module.exports = "/_next/static/videos/golf-3-dc0ab1a590dd54d048b003ff1807ef14.webm";